import { action, observable } from "mobx";

import apiCaller from "@client/utils/ApiCaller";
import { RoleAssignment } from "@typings/Identity";

class RoleStore {
  @observable roles: string[] = [];
  @observable roleAssignments: RoleAssignment[] = [];

  async load(config?: { isPartner?: boolean }): Promise<void> {
    const roles: string[] = await apiCaller.send({
      url: `/roles?isPartner=${config?.isPartner || false}`,
    });
    this.loadSuccess(roles);
  }

  @action loadSuccess(roles: string[]) {
    this.roles = roles;
  }

  async loadRoleAssignments(): Promise<void> {
    const roleAssignments: RoleAssignment[] = await apiCaller.send({
      url: "/role_assignments",
    });
    this.loadRoleAssignmentsSuccess(roleAssignments);
  }

  @action loadRoleAssignmentsSuccess(roleAssignments: RoleAssignment[]) {
    this.roleAssignments = roleAssignments;
  }
}

export default new RoleStore();
